export default "/images/73798222c433ab260f522c420d0c9eb4.avif";